import { render, staticRenderFns } from "./ContactDistributionsByContactProperty.vue?vue&type=template&id=6c364bab&scoped=true"
import script from "./ContactDistributionsByContactProperty.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByContactProperty.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByContactProperty.vue?vue&type=style&index=0&id=6c364bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c364bab",
  null
  
)

export default component.exports